import React from 'react'

import { Toaster } from 'react-hot-toast'

interface SubmitButtonProps {
  companyColor: string
  text: string
  dark: boolean
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ companyColor, text, dark }: SubmitButtonProps) => (
  <div className="h-full flex max-[632px]:w-full max-[632px]:justify-center">
    <div
      className="rounded-xl w-full cursor-pointer"
      style={{ backgroundColor: dark ? companyColor : 'white', color: dark ? 'white' : companyColor }}
    >
      <button
        type="submit"
        tabIndex={0}
        className="flex justify-center items-center font-medium font-['Onest'] h-full w-full"
      >
        {text}
      </button>
    </div>

    <Toaster />
  </div>
)

export default SubmitButton
